export default {
    // Default variant (current style)
    //-------------------------------------------------------------------------
    default: {
      container: "fixed top-4 left-0 w-full flex justify-center",
      notification: "fixed top-10 transform -translate-x-1/2 bg-primary text-white p-4 rounded shadow-lg flex items-center",
      message: "text-white",
      closeButton: "ml-4 text-white focus:outline-none hover:text-neutral_2",
    },

    // Success variant
    //-------------------------------------------------------------------------
    success: {
      container: "fixed top-4 left-0 w-full flex justify-center",
      notification: "fixed top-10 transform -translate-x-1/2 bg-success text-white p-4 rounded shadow-lg flex items-center",
      message: "text-white",
      closeButton: "ml-4 text-white focus:outline-none hover:text-neutral_2",
    },

    // Error variant
    //-------------------------------------------------------------------------
    error: {
      container: "fixed top-4 left-0 w-full flex justify-center",
      notification: "fixed top-10 transform -translate-x-1/2 bg-error text-white p-4 rounded shadow-lg flex items-center",
      message: "text-white",
      closeButton: "ml-4 text-white focus:outline-none hover:text-neutral_2",
    },

    // Admin variant
    //-------------------------------------------------------------------------
    admin: {
        container: "fixed top-4 left-0 w-full flex justify-center",
        notification: "fixed top-10 transform -translate-x-1/2 bg-admin_primary text-white p-4 rounded shadow-lg flex items-center",
        message: "text-white",
        closeButton: "ml-4 text-white focus:outline-none hover:text-admin_neutral_2",
    },
  }